import { UAParser } from "ua-parser-js";

const getDeviceInfo = () => {
    const parser = new UAParser();
    const details = parser.getResult();

    const { os, device, browser } = details;

    const downloadInfo = `${os.name ? os.name : ""} : ${
        device.model ? device.model : ""
    } ${device.type ? device.type : ""} : ${browser.name} : ${
        browser.version
    } ::\n Navigator: ${navigator.userAgent} -- ${JSON.stringify(details)}`;

    
    /** Check if the package works fine  */
        // const os = details.os.name;
    //const userAgent = navigator.userAgent.toLowerCase();
    // let browserName = "Unknown Browser",
    //     browserVersion = "";

    // if (userAgent.includes("chrome")) browserName = "Chrome";
    // else if (userAgent.includes("firefox")) browserName = "Firefox";
    // else if (userAgent.includes("safari")) browserName = "Safari";
    // else if (userAgent.includes("edge")) browserName = "Edge";
    // else if (userAgent.includes("msie") || userAgent.includes("trident"))
    //     browserName = "Internet Explorer";

    // const versionStart =
    //     userAgent.indexOf(browserName.toLowerCase()) + browserName.length + 1;
    // browserVersion = userAgent.substring(versionStart).split(" ")[0];

    // const platform = navigator.platform.toLowerCase();
    // let os = "Unknown Operating System";

    // if (platform.includes("win")) os = "Windows";
    // else if (platform.includes("mac")) os = "MacOS";
    // else if (platform.includes("linux")) os = "Linux";
    // else if (platform.includes("android")) os = "Android";
    // else if (
    //     platform.includes("iphone") ||
    //     platform.includes("ipad") ||
    //     platform.includes("ipod")
    // )
    //     os = "iOS";

    return downloadInfo;
};

export default {
    getDeviceInfo,
};
